<template>
  <div class="area-with-units" v-if="size">
    <span v-if="unit === 'ha'">
      {{ formatAreaSize(size / 10000) }}
      ha
    </span>
    <span v-else>
      {{ formatAreaSize(size) }}
      m<sup>2</sup>
    </span>
  </div>
</template>

<script setup lang="ts">
import utils from '@/app/utils/utils';

type AreaUnit = 'm2' | 'ha' | null;

defineProps<{
  size: number;
  unit?: AreaUnit;
}>();

const formatAreaSize = (size: number) => {
  const decimals = Number.isInteger(size) ? 0 : 1;
  return utils.formatNumber(size, decimals);
};
</script>
